module.exports = __webpack_public_path__ + "static/media/juicy-fruits.c9994748.gif";